// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const RangeSlider = ((($) => {
  function init() {
    $('.js-range-slider').ionRangeSlider({
      type: 'double',
      min: 0,
      max: 200,
      from: 50,
      to: 200,
      grid: false,
      postfix: 'm2',
    });
  }

  return {
    init,
  };
}))(jQuery);


// don't forget to export
export default RangeSlider;



// WEBPACK FOOTER //
// ./src/static/js/modules/range-slider.js